export const TOGGLE_CURRENT_PASSWORD_SHOW_HIDE = "users/TOGGLE_CURRENT_PASSWORD_SHOW_HIDE";

export default function toggleCurrentPasswordShowHideAction() {
  return {
    "payload": {},
    "type": TOGGLE_CURRENT_PASSWORD_SHOW_HIDE
  };
}
